import { useEffect, useState } from 'react';
// import dayjs from 'dayjs';
import CardV from 'src/components/cards/card-v';
import { API_URI, SHOW_COMMEMORATE } from 'src/constants';
// import { convertObjPath } from 'src/utils/helper';
import _ from 'lodash';
import { GET } from 'src/utils/services';
import SectionLive from '../section-video/section-live';

const SectionEventEnergy = ({ energy = [], eventDataLayer }) => {
  let dataEnergy = [];
  if (!_.isEmpty(energy)) {
    dataEnergy = energy;
  }

  const [newsData, setNewsData] = useState(null);
  const [videoEnergy, setVideoEnergy] = useState(null);

  useEffect(async () => {
    const resVideoEnergy = await GET('/api/v1.0/video/section-two');
    if (!_.isEmpty(resVideoEnergy)) {
      setVideoEnergy(resVideoEnergy);
    }
    const res = await fetch(
      `${API_URI}/api/search/advertorials/tag?name=%E0%B8%A3%E0%B8%B2%E0%B8%84%E0%B8%B2%E0%B8%99%E0%B9%89%E0%B8%B3%E0%B8%A1%E0%B8%B1%E0%B8%99%E0%B8%94%E0%B8%B4%E0%B8%9A&limit=1`
    );
    const resJson = await res.json();
    if ('msg' in resJson) {
      setNewsData(null);
    } else {
      setNewsData(resJson);
    }
  }, []);

  let firstData = null;
  if (newsData !== null) firstData = [...newsData.data].shift();

  return (
    <>
      {!_.isEmpty(dataEnergy) && !_.isEmpty(newsData?.data) && (
        <div className='section-event-3 'style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
          <div className='event-area'>
            <section className='background-wrapper' style={{ background: `url(${dataEnergy?.dataSet[0].value}) center top no-repeat`, backgroundSize: 'cover' }}>
              <div className='section-content'>
                <div id='event-header' className='section-wrapper mb-4'>
                  <img src={dataEnergy?.dataSet[2].value} alt={dataEnergy?.topic} width='100%' height='100%' />
                  <h2>วิเคราะห์สถานการณ์ราคาน้ำมัน</h2>
                </div>

                <div id='event-content' className='content-energy'>
                  <div className='col-lg-6 col-md-6 col-xs-12 content-item --left  '>
                    <SectionLive
                      data={videoEnergy}
                      secEnergy={true}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          block: '1',
                          heading: 'energy'
                        }
                      }}
                    />
                  </div>
                  <div className='col-lg-6 col-md-6 col-xs-12 content-item --right  '>
                    <CardV
                      data={firstData}
                      light={true}
                      path={firstData?.link}
                      //! DATALAYER
                      eventDataLayer={{
                        ...eventDataLayer,
                        data: {
                          block: '2',
                          ...eventDataLayer?.data,
                          title: firstData?.title,
                          heading: 'energy'
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div id='event-footer' className='section-wrapper --end grid-img'>
                <img src={dataEnergy?.dataSet[1].value} alt={dataEnergy?.topic} width='100%' height='100%' />
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default SectionEventEnergy;
